import { generateMutationsFor } from '@/store/tools'

let mutations = [
  'REFRESH',
  'ADD',
  'DELETE',
  'UPDATE',
  'UPDATE_FILTERS',
  'CHANGE_PAGE',
  'CHANGE_PAGE_SIZE',
  'CHANGE_CURRENT_STAFF',
  'CHANGE_ADDING',
  'UPDATE_STAFF_DIALOG_VISIBLE',
  'OPEN_DIALOG_FOR_ADDING',
  'OPEN_DIALOG_FOR_UPDATING',
  'CHANGE_LOADING',
  'RESET_QUERY_INFO'
]

export default generateMutationsFor(mutations)
